import { useState, useEffect, useCallback } from 'react';
import type { PeerCoordinator } from '../PeerCoordinator';

export type PauseStateInfo = {
  globalPaused: boolean;
  playerPauses: Record<string, boolean>;
};

/**
 * Reactive hook for global and per-player pause state.
 */
export function usePauseState(coordinator: PeerCoordinator): PauseStateInfo {
  const [state, setState] = useState<PauseStateInfo>({
    globalPaused: coordinator.isGloballyPaused(),
    playerPauses: {},
  });

  const handleChange = useCallback(
    (event: { peerId?: string; paused: boolean; global: boolean }) => {
      setState((prev) => {
        if (event.global) {
          return { ...prev, globalPaused: event.paused };
        }
        if (event.peerId) {
          return {
            ...prev,
            playerPauses: { ...prev.playerPauses, [event.peerId]: event.paused },
          };
        }
        return prev;
      });
    },
    [],
  );

  useEffect(() => {
    return coordinator.events.pauseStateChanged.addListener(handleChange);
  }, [coordinator, handleChange]);

  return state;
}
